import getValuesArray from '@/utils/array/getValuesArray'

export default function (arr, key = 'id') {
  return getValuesArray(arr, key)
    .join(',')
}
